import {PageData} from '@epic-mw/types';
import {useStore} from '../stores';

export const useLoading = (pageData: PageData): boolean => {
    const [store] = useStore();
    const loading = store.loading || pageData === undefined || false;

    return loading;
};

export const useNotFound = (pageData: PageData): boolean => {
    const loading = useLoading(pageData);

    return !loading && !pageData?._urlPattern;
};
